import { createMuiTheme } from "@material-ui/core/styles"

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      "Noto Sans JP",
      "ヒラギノ角ゴ ProN W3",
      "Meiryo",
      "sans-serif",
    ].join(","),
  },
  palette: {
    primary: {
      main: "#FA7D3D",
      contrastText: "#fff",
    },
    secondary: {
      main: "#293D62", // orange[500],
    },
  },
})

export default theme
